export class Extra {
    id: number;
    externalId: string;
    name: string;
    defaultPrice: number;

    public static fromApi(apiExtra: any): Extra {
        const extra = new Extra();
        extra.id = apiExtra.id;
        extra.externalId = apiExtra.externalId;
        extra.name = apiExtra.name;
        extra.defaultPrice = apiExtra.defaultPrice;
        return extra;
    }

}

export default Extra;
